module.exports = __webpack_public_path__ + "img/fixe.062bdfca.png";